<template>
  <v-sheet class="bg-transparent grant-access-page">
    <v-container fluid>
      <v-card>
        <v-row align="center">
          <v-col md="4" cols="4" justify="center">
            <v-img alt="Access Lock"
                   class="shrink mr-4"
                   :src="require('../../src/assets/lock-round.jpg')"
                   transition="scale-transition"
                   width="500" />
          </v-col>
          <v-col md="8" cols="8">
            <v-row>
              <v-col>
                <div class="text-left container">
                  <h2 class="py-10 pr-10 mds-font--display-3">You've stumbled on restricted access</h2>
                  <p class="mds-font--display-1">
                    Only some people can view this. If you think you should be one of them,
                    request access from the Admin
                  </p>
                  <mc-button variant="primary" @click="openWindow()">Request Access</mc-button>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-dialog v-model="popup" width="auto">
      <v-card class="rm-border">
        <v-toolbar color="#0CA0CE" dark>
          <v-toolbar-title>Request Access</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="ml-14" height="25px" x-small depressed color="white" @click="closePopup()"> <v-icon small color="black">mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-row align="center" class="m-0">
                  <v-col md="12">
                    <v-text-field v-model="userEmail"
                                  label="E-mail"
                                  disabled
                                  ></v-text-field>
                  </v-col>
                  <v-col md="12">
                    <v-select v-model="selectedRole"
                              :items="items"
                              label="Selected User Role"
                              dense
                              outlined
                              disabled>
                    </v-select>
                  </v-col>
          <v-col md="12">
            <v-textarea v-model="comments"
                        label="Reason"
                        outlined
                        rows="3"
                        no-resize
                        placeholder="Enter a reason"
            ></v-textarea>
          </v-col>
          <v-col md="12">
            <mc-button
                label="Submit"
                appearance="primary"
                width="full-width"
                class="p-5"
                @click="submit"
                :disabled="userEmail.length===0 || comments.length===0"
            >
            </mc-button>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <mc-toast
        :open="showStatus"
        position="bottom-center"
        duration="3000"
        :appearance="appearNotify">
      <mc-notification :body="notifyHeaderText"></mc-notification>
    </mc-toast>
  </v-sheet>
</template>

<script>
import { avActions } from "@/actions";
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import {store} from '@/store/store'
import '@maersk-global/mds-components-core-modal';
import '@maersk-global/mds-components-core-button';
import '@maersk-global/mds-components-core-notification';
import '@maersk-global/mds-components-core-toast';

export default {
  name: 'unAuthorized',
  store,
  components: {
  },
  data() {
    return {
      showStatus: false,
      selectedRole: 'VIEWER',
      successNotify: false,
      comments: '',
      popup:false,
      userName: '',
      userEmail: '',
      select: null,
      trade:[],
      vertical:[],
      salesRegion:[],
      checkbox: false,
      items: ['VIEWER'],
      notifyHeaderText: '',
      appearNotify : 'info',
    }
  },
  async mounted() {
    await this.initialize();
  },
  methods :{
    openWindow(){
      this.popup = true;
      this.showStatus=false;
      this.appearNotify = 'info';
    },
    async submit(){
      const accessTokenCheck = JSON.parse(sessionStorage.getItem('av_msal_token'))
      const postBody = {
        userEmail: this.userEmail,
        memberRole: "VIEWER",
        status: "NEW",
        comments: this.comments,
        createdBy: this.userEmail
      }
      const registerOptions = await avActions.registerUserOnApp(
          postBody,
          accessTokenCheck.idToken
      );
      const registerResponse = await AxiosFetchForMsal(registerOptions);
      if (registerResponse.status === 200) {
        this.closePopup();
        this.notifyHeaderText = 'Your request to access the application has been sent successfully';
        this.appearNotify = 'success';
        this.successNotify = true;
        this.showStatus=true;
      } else if (registerResponse.status === 409) {
        this.closePopup();
        this.notifyHeaderText = 'You have already raised a request. Please reach out to the Admin for approval.';
        this.appearNotify = 'error';
        this.successNotify = true;
        this.showStatus=true;
      } else {
        this.closePopup();
        this.notifyHeaderText = 'Please try again later.';
        this.appearNotify = 'info';
        this.successNotify = true;
        this.showStatus=true;
      }
    },
    async initialize(){
      const accessTokenCheck = JSON.parse(sessionStorage.getItem('av_msal_token'))
      this.userName = accessTokenCheck.account.name;
      this.userEmail = accessTokenCheck.account.username.toLowerCase();
    },
    closePopup(){
      this.popup = false;
      this.selectedRole = 'VIEWER';
      this.comments= '';
    },
  }
}
</script>
<style scoped>
</style>

